// src/App.jsx
import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { LanguageProvider } from './context/LanguageContext';
import LandingPage from './pages/Landing/LandingPage';
import Service from './pages/Services/Service';
import ProjectsPage from './pages/Services/ProjectsPage';
import Clients from './pages/Clients/Clients';
import AboutUs from './pages/AboutUs/AboutUs';
import ContactUs from './pages/Contact/ContactUs';
import Careers from './pages/Careers/Careers';
import HireUs from './pages/HireUs/HireUs';

function App() {
  return (
    <LanguageProvider>
      <Router>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/services" element={<Service />} />
          <Route path="/projects" element={<ProjectsPage />} />
          <Route path="/clients" element={<Clients />} />
          <Route path="/about" element={<AboutUs />} />
          <Route path="/aboutus" element={<AboutUs />} />
          <Route path="/contact" element={<ContactUs />} />
          <Route path="/careers" element={<Careers />} />
          <Route path="/hireus" element={<HireUs />} />
        </Routes>
      </Router>
    </LanguageProvider>
  );
}

export default App;
